import { render, staticRenderFns } from "./ActivityConfigListPage.vue?vue&type=template&id=53c9cf5e&scoped=true"
import script from "./ActivityConfigListPage.vue?vue&type=script&lang=js"
export * from "./ActivityConfigListPage.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigListPage.vue?vue&type=style&index=0&id=53c9cf5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9cf5e",
  null
  
)

export default component.exports